import { API_NAMES, initApi } from '../../utils/HttpApiHelper';
import { BASIC_INITIAL_STATE } from '../../utils/HttpHelper';

const runKendoReport = (reportId, reportParameters, state, setState) => {
  const api = initApi(API_NAMES.COMMON, state, setState);
  const url = `/ReportInfo/ExecuteReport/${reportId}`;
  return api?.executeObject ? api.executeObject(url, 'POST', reportParameters) : null;
};

const getDynamicReportTitle = (reportId, reportParameters, state, setState) => {
  const api = initApi(API_NAMES.COMMON, state, setState);
  const url = `/ReportInfo/GenerateReportTitle/${reportId}`;
  return api?.executeObject ? api.executeObject(url, 'POST', reportParameters) : null;
};

const EmbeddedKendoReportData = {
  INITIAL_STATE: { ...BASIC_INITIAL_STATE },
  runKendoReport,
  getDynamicReportTitle
};

export default EmbeddedKendoReportData;